import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { Row, Col, Form, Button, Alert } from "react-bootstrap";
import {
  signIn,
  resetSignIn,
  signInGoogle,
  signInFacebook,
  signInApple,
  getRegisterOtp,
} from "../../actions/auth-action";
import { Redirect, useHistory, useLocation, Link } from "react-router-dom";
import { getCurrentTimeZone } from "../../utils/Utils";
import { GoogleLogin } from "react-google-login";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import AppleLogin from "react-apple-login";
import "./TokoSignUp.scss";
import "./TokoSignIn.scss";
import { TokoRefCode } from "../../Const";

const TokoSignIn = (props) => {
  const history = useHistory();
  const { resetSignIn, signIn, signInGoogle, signInFacebook, signInApple } =
    props;
  const location = useLocation();
  const host = window.location.origin;
  const hash = window.location.hash;
  const token = useSelector((state) => state.auth.token);
  const user = useSelector((state) => state.auth.user);
  const errorMessage = useSelector((state) => state.auth.errorMessage);
  const signInStart = useSelector((state) => state.auth.signInStart);
  const pathname = (location.state && location.state.from) || "/dashboard";
  const gaConfirmed = useSelector((state) => state.auth.gaConfirmed);
  const gaEnabled = useSelector((state) => state.settings.gaEnabled);

  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");

  useEffect(() => {
    resetSignIn();
    return () => resetSignIn();
  }, []);

  useEffect(() => {
    const currentTimezone = getCurrentTimeZone();
    window.timezone = currentTimezone;
  }, []);

  const login = (e) => {
    e.preventDefault();
    signIn(email, pass);
  };

  const loginGoogle = (res) => {
    const { tokenId } = res;
    signInGoogle(tokenId, TokoRefCode);
  };

  const loginFacebook = (res) => {
    const { accessToken, userID } = res;
    signInFacebook(accessToken, userID, TokoRefCode);
  };

  const loginApple = (res) => {
    console.log("Apple", res);
  };

  const failedLoginGoogle = (res) => {
    console.log("Failed login Google", res);
  };

  useEffect(() => {
    if (hash) {
      const idTokenIndex = hash.indexOf("id_token");
      const idToken = hash.slice(idTokenIndex + 9);
      signInApple(idToken, TokoRefCode);
    }
  }, [hash]);

  if (token) {
    if (user && user.email_verified_at) {
      if (gaEnabled && !gaConfirmed) return <Redirect to="/ga/confirm" />;
      return <Redirect to={pathname} />;
    }
    return <Redirect to="/verify-otp" />;
  }
  return (
    <div className="toko-signup toko-signin">
      <Row>
        <Col className="left-panel">
          <div>
            <img
              src="/images/ch2.png"
              className="crytohero-image"
              width="150"
            />
            <img src="/images/toko.png" className="toko-image" width="180" />
          </div>
          <div>
            <img src="/images/login.png" className="feature-image" />
          </div>
        </Col>
        <Col className="right-panel">
          <div className="signup-panel">
            <h6 className="header-text" style={{ marginTop: 120 }}>
              Log in to your account
            </h6>
            <Form style={{ marginTop: 40 }}>
              <Form.Group controlId="formBasicEmail" className="toko-form">
                <Form.Control
                  type="email"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Form.Group>

              <Form.Group controlId="formBasicPassword" className="toko-form">
                <Form.Control
                  type="password"
                  placeholder="Password"
                  value={pass}
                  onChange={(e) => setPass(e.target.value)}
                />
              </Form.Group>

              <div className="forgot-pass">
                <Link to="/forget-pass">Forgot Password?</Link>
              </div>
              <div className="my-3">
                <Button type="submit" onClick={login} className={"toko-button"}>
                  {signInStart ? "PROCESSING..." : "LOGIN NOW"}
                </Button>
                <Button
                  type="submit"
                  onClick={() => history.push("/tokosignup")}
                  className={"toko-button-login"}
                >
                  CREATE ACCOUNT
                </Button>
              </div>

              <Alert
                show={errorMessage != null}
                variant="danger"
                className="mt-2"
              >
                {errorMessage && errorMessage}
              </Alert>
            </Form>

            {/* <div className="text-center mt-5">Or you can login with</div>
            <div className="mt-4 text-center">
              <FacebookLogin
                appId="649699255566506"
                fields="name,email,picture"
                callback={loginFacebook}
                render={(renderProp) => {
                  return (
                    <div className="circle text-center">
                      <a onClick={renderProp.onClick}>
                        <i className="fab fa-facebook-f facebook"></i>
                      </a>
                    </div>
                  );
                }}
              />

              <GoogleLogin
                clientId={
                  "189770389469-bq5adf9q4er1a8lmbgukr2oc81is3jt2.apps.googleusercontent.com"
                }
                onSuccess={loginGoogle}
                onFailure={failedLoginGoogle}
                render={(renderProp) => {
                  return (
                    <div className="circle text-center">
                      <a onClick={renderProp.onClick}>
                        <i className="fab fa-google-plus-g google"></i>
                      </a>
                    </div>
                  );
                }}
              ></GoogleLogin>

              <AppleLogin
                clientId="capital.novum.stockhero.web"
                redirectURI={`${host}/tokocrypto`}
                callback={loginApple}
                responseType="code id_token"
                responseMode="fragment"
                render={(renderProp) => {
                  return (
                    <div className="circle text-center">
                      <a onClick={renderProp.onClick}>
                        <i className="fab fa-apple apple"></i>
                      </a>
                    </div>
                  );
                }}
              />
            </div>
           */}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default connect(null, {
  signIn,
  resetSignIn,
  signInGoogle,
  signInFacebook,
  signInApple,
  getRegisterOtp,
})(TokoSignIn);
